// extracted by mini-css-extract-plugin
export var container = "opinion-module--container--2shyb";
export var opinion = "opinion-module--opinion--7S-90";
export var writer = "opinion-module--writer--6OsmW";